export default async (instance, current, totalPer) => {
  const apiRequest = await fetch(
    `${instance}api/competition-winners?currentPage=${current}&totalPer=${totalPer}`,
    { credentials: 'include' }
  )
  const result = await apiRequest.json()

  return result
}
